import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import TransportadorasGrid from './TransportadorasGrid.js'
import TransportadorasAbm from './TransportadorasAbm.js'
import {FormattedMessage, injectIntl} from 'react-intl';

class Transportadoras extends Component {
	render() {
	    return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
      					<h3 className="content-header-title"><FormattedMessage id="Transportadoras.titulo.administracion_transportadoras" defaultMessage="Administración de Transportadoras"/></h3>
      				</div>
				</div>
				<div className="content-body">								
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={TransportadorasGrid} />
						<Route exact path={`${this.props.match.url}/add`} render={(props) => <TransportadorasAbm {...props} action="ADD" />} />
						<Route exact path={`${this.props.match.url}/:id/edit`} render={(props) => <TransportadorasAbm {...props} action="EDIT" />} />
						<Route exact path={`${this.props.match.url}/:id`} render={(props) => <TransportadorasAbm {...props} action="VIEW" />} />
					</Switch>										
				</div>
			</div>
	    );
  	}
}

export default injectIntl(Transportadoras);
